import UnderlyingAssetTypeAPI from "../../../api/UnderlyingAssetTypeAPI";
import UnderlyingAssetType from '../../../models/underlyingAssetType/UnderlyingAssetType';

export default {
  async loadAllUnderlyingAssetTypes({
    commit
  }) {
    const response = await new UnderlyingAssetTypeAPI().all();
    const result = [];
    for (let i = 0; i < response.length; i++) {
      result.push(UnderlyingAssetType.createFromData(response[i]))
    }
    commit("SET_ALL_UNDERLYING_ASSET_TYPES", result);
  },
};
